<template>
    <el-container>
        <el-aside :width="menuWidth">
            <div class="logo">
                <!-- <i class="el-icon-share"></i> -->
                <router-link :to="index_path">
                    <div style="display: flex;justify-content: center">
                    <img src="../assets/images/login-icon.png" v-if="!isCollapse"
                         alt="logo">
                    <img src="../assets/images/login-icon.png"  style="height: 20px;width: 20px;border-radius:5px;margin: 17px 0" v-else
                         alt="logo">
                    </div>
                </router-link>
                <!-- L<span style="color:red;font-weight:bold;font-size:110%;">i</span>NC -->
            </div>
            <el-menu class="aside-menu"
                     router
                     unique-opened
                     :collapse="isCollapse"
                     :collapse-transition="false"
                     style="width:100%;"
                     :default-active="$route.path"
                     background-color="rgb(75, 80, 93)"
                     text-color="#fff"
                     active-text-color="#409eff">
                <el-menu-item :index="'/rms/registration?' + Math.random()" v-if="groups != '3'">
                    <i class="el-icon-document"></i>
                    <span slot="title">患者登记</span>
                </el-menu-item>
                <el-menu-item index="/rms/archives">
                    <i class="el-icon-user-solid"></i>
                    <span slot="title">患者管理</span>
                </el-menu-item>
                <el-menu-item index="/rms/report/statistics" v-if="overview==1">
                    <i class="el-icon-pie-chart"></i>
                    <span style="font-size:15px">数据视图</span>
                </el-menu-item>
                <!--                <el-menu-item index="/rms/report/jupyter">-->
                <!--                    <i class="el-icon-s-data"></i>-->
                <!--                    <span style="font-size:15px">分析统计</span>-->
                <!--                </el-menu-item>-->
                <!--                <el-submenu index="/rms/report">-->
                <!--                    <template slot="title">-->
                <!--                        <i class="el-icon-menu"></i>-->
                <!--                        <span style="font-size:15px">数据视图</span>-->
                <!--                    </template>-->
                <!--                    <el-menu-item index="/rms/report/costStatistics">费用统计</el-menu-item>-->
                <!--                    <el-menu-item index="/rms/report/diseaseCtrlChart">病例分布</el-menu-item>-->
                <!--                    <el-menu-item index="/rms/report/diseaseAnalysisChart">疾病分析</el-menu-item>-->
                <!--                    <el-menu-item index="/rms/report/statistics">分析统计</el-menu-item>-->
                <!--                </el-submenu>-->
                <!--                <el-menu-item index="/rms/system/user" v-if="is_admin == 'true' || groups == 'true'">-->
                <!--                    <i class="el-icon-view"></i>-->
                <!--                    <span slot="title">用户审核</span>-->
                <!--                </el-menu-item>-->
                <el-menu-item index="/rms/institution" v-if="groups != '3'">
                    <i class="el-icon-star-on"></i>
                    <span slot="title">医院信息</span>
                </el-menu-item>
                <el-menu-item index="/rms/help">
                    <i class="el-icon-question"></i>
                    <span slot="title">案例示范</span>
                </el-menu-item>
                <el-menu-item index="/rms/dowload">
                    <i class="el-icon-folder"></i>
                    <el-badge value="new" class="item" slot="title">
                        <span >数据共享</span>
                    </el-badge>
                </el-menu-item>
            </el-menu>
        </el-aside>
        <el-container>
            <el-header>
                <el-row>
                    <el-col :span="8">
                        <el-button type="text" style="font-size:17px"
                                   @click="handleCollapse"
                                   icon="el-icon-menu"></el-button>
                    </el-col>
                    <el-col :span="16" class="header-right"
                            style="text-align:right">
<!--                        <router-link class="iconButton" to="/rms/dowload">-->
<!--                            <el-badge :value="1" class="badge" >-->
<!--                                <img src="../assets/images/dowload.png" style="width: 23px"/>-->
<!--                            </el-badge>-->
<!--&lt;!&ndash;                            <i class="el-icon-message" ></i>&ndash;&gt;-->
<!--                        </router-link>-->
                        <el-dropdown>
                            <span class="el-dropdown-link">
                                {{ username }}
                                <img
                                     src="../assets/images/avatar.png"
                                     class="user-avatar">
                                <i class="el-icon-arrow-down el-icon--right"></i>
                            </span>
                            <el-dropdown-menu slot="dropdown">
                                <router-link :to="index_path">
                                    <el-dropdown-item>
                                        首页
                                    </el-dropdown-item>
                                </router-link>
                                <router-link to="/rms/password">
                                    <el-dropdown-item>修改密码</el-dropdown-item>
                                </router-link>
                                <router-link to="/logout">
                                    <el-dropdown-item divided>退出登陆</el-dropdown-item>
                                </router-link>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <transition name="el-fade-in-linear">
                    <router-view>
                    </router-view>
                </transition>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    export default {
        data() {
            return {
                username: '管理员',
                isCollapse: false,
                menuWidth: '180px',
                is_admin: false,
                groups: false,
                index_path: '/rms/dashboard',
                overview: 0,
            }
        },
        methods: {
            handleCollapse() {
                this.isCollapse = !this.isCollapse
                this.menuWidth = this.isCollapse ? '65px' : '180px'
            }
        },
        mounted() {
            this.username = localStorage.getItem('username')
            this.is_admin = localStorage.getItem('is_admin')
            this.groups = localStorage.getItem('groups')
            this.$http.get(`/case/update/`)
                .then(resp => {
                    this.overview = resp.data.overview
                    localStorage.setItem('tool', resp.data.tool)
                    localStorage.setItem('sk', resp.data.sk)
                    if (resp.data.code == 1) {
                        this.$notify({
                            title: '消息',
                            type: 'warning',
                            message: '您有患者病例需要随访更新,请及时处理。',
                            duration: 0
                        });
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    };
</script>

<style scoped>
    .el-aside {
        background-color: rgb(75, 80, 93);
        color: #fff;
        overflow: hidden;
    }
    ::v-deep .el-badge__content.is-fixed {
        top: 20px;
        right: 0px;
    }
     ::v-deep .el-badge__content {
         line-height: 15px;
         padding: 0 4px;
          border: 0px solid;
     }
    .logo {
        color: #fff;
        background-color: rgb(75, 80, 93);
        font-size: 120%;
        font-weight: bold;
    }

    .logo img {
        height: 54px;
        vertical-align: middle;
    }

    .el-header {
        background-color: #fff;
        border-radius: 0 !important;
        border-bottom: 1px solid #e6e6e6;
        height: 55px !important;
        line-height: 55px;
        color: #234;
    }

    .el-submenu__title i {
        color: white;
    }

    .el-menu-item:hover,
    .el-submenu__title:hover {
        background-color: rgb(38, 52, 69) !important;
    }

    .el-menu .is-active {
        /* background-color: rgb(38, 52, 69) !important; */
    }

    .el-menu {
        background-color: rgb(75, 80, 93);
        border-right: none;
        width: 180px;
    }

    .el-menu-item span {
        font-size: 15px;
    }

    .el-menu-item i {
        color: #fff;
    }

    .el-dropdown-link {
        cursor: pointer;
    }

    .el-icon-arrow-down {
        font-size: 12px;
    }

    .user-avatar {
        width: 40px;
        height: 40px;
        border-radius: 10px;
        vertical-align: middle;
    }

    .el-dropdown-menu a {
        text-decoration: none;
    }

    .el-main {
        padding: 10px;
    }

    .main-container {
        background-color: #fff;
        padding: 10px;
    }

    .header-right .iconButton {
        width: 50px;
        margin: 2px;
        /*padding: 0;*/
        text-align: center;
        cursor: pointer;
        padding-right: 20px;
        /*color: #fff;*/
    }

    ::v-deep .iconButton .el-badge {
        line-height: 20px;
        height: 20px;
        padding: 0
    }

    ::v-deep .iconButton i {
        font-size: 120%;
        /*color: #3a8ee6;*/
    }

</style>
